export default __webpack_public_path__ + "static/media/frasersTower.jpg?.ae1757e0";